
import React from "react";
import ReactModal from "react-modal";
import { deleteUser } from "../../api";

type propsType = {
    openDeleteModal: boolean
    setOpenDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
    concretUser: any,
    setConcretUser: React.Dispatch<React.SetStateAction<any>>,
    gettingUsersData: () => Promise<void>,
}

function DeleteUser(props: propsType) {

    const {
        openDeleteModal,
        setOpenDeleteModal,
        setConcretUser,
        gettingUsersData,
        concretUser
    } = props;

    const closeWindow =  () : void=> {
        setConcretUser(null);
        setOpenDeleteModal(false);
    }

    const deleteThisClient = async (): Promise<void> => {
        const responseData = await deleteUser(concretUser.id);
        if (responseData) {
            await gettingUsersData();
            closeWindow();
        }
    }

    return (
        <ReactModal
            isOpen = { openDeleteModal }
            onRequestClose = { () => closeWindow() }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "240px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-deleteClient-content'>
                Do You Want to Delete this User?
            </div>
            <p className = "concretClienFullName">{ concretUser.fullName }</p>
            <div className = 'modal-deleteClient-actions'>
                <button
                    className = "rejectAction"
                    onClick = { closeWindow }
                >
                    No
                </button>
                <button
                    className = "confirmAction"
                    onClick = { deleteThisClient }
                >
                    Yes
                </button>
            </div>
        </ReactModal>
    )
}

export default DeleteUser
